import React from 'react';
import useChatStarterPrompts from '@/hooks/useChatStarterPrompts';
import StarterSuggestions from '@/components/StarterSuggestions';
import { pickWorkSuggestionItems } from '@/constants/work';

const DEFAULT_SUGGESTIONS = [
  { id: 'learn', icon: 'book-open', label: 'Learn something new', prompt: 'Teach me a surprising idea and help me understand it with a simple example.', promptWithFiles: 'Help me understand the key ideas in the attached material, using simple explanations and examples.' },
  { id: 'ideas', icon: 'lightbulb', label: 'Explore an idea', prompt: 'Help me brainstorm a fresh idea. Start by asking what I would like to explore.', promptWithFiles: 'Help me brainstorm fresh ideas inspired by the attached material.' },
  { id: 'decision', icon: 'compass', label: 'Think it through', prompt: 'Help me think through a decision. Start by asking what I am weighing up.', promptWithFiles: 'Help me think through the options and tradeoffs in the attached material.' },
];

export default function ChatStarterSuggestions({ onSelect, hasFiles = false, enabled = true }) {
  const { items } = useChatStarterPrompts({ enabled });
  const suggestions = pickWorkSuggestionItems(items, DEFAULT_SUGGESTIONS);
  return (
    <StarterSuggestions
      items={suggestions}
      onSelect={onSelect}
      hasFiles={hasFiles}
      accessibilityLabel={suggestions === DEFAULT_SUGGESTIONS ? 'Chat suggestions' : 'Suggested conversations based on your memory'}
    />
  );
}
